export const COLORS = {
    primary: "#594099",
    secondary: "#F5A623",
    danger: "#FF6B6B",
    info: "#4ECDC4",
    success: "#22B573",
    successLight: "#F0FFF5",
    dangerLight: "#FFF0F0",
    textDark: "#1A1A1A",
    textBlack: "#191919",
    textLight: "#636363",
    bgLight: "#FAFAFA",
    borderLight: "#E6E6E6",

    primaryLight: "#EDE9F9",
    chartBlue: "#1982C4",
    chartBlueLight: "#D8F0FF",
    chartGreen: "#8AC926",
    chartGreenLight: "#DCF2B7",
    axisGray: "#AEAEAE",
    placeholderGray: "#999999",
    tableHeaderText: "#A1A1A1",
    tableHeaderBg: "#F3F3F3",
    subtleBg: "#F9F9F9",
    borderDark: "#B3B3B3",
    pillBg: "#D9D9D9",
    statusActiveBg: "#ECFDF5",
    statusActiveText: "#059669",
    statusInactiveBg: "#FFFBEB",
    statusInactiveText: "#D97706",
    pageBg: "#F5F5F5",
};

export const BREAKPOINTS = {
    mobile: 768,
    tablet: 1024,
};

export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
